/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function CompanyListFromJSON(json) {
    return CompanyListFromJSONTyped(json, false);
}
export function CompanyListFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        id: !exists(json, 'id') ? undefined : json['id'],
        name: !exists(json, 'name') ? undefined : json['name'],
        createdAt: !exists(json, 'created_at') ? undefined : json['created_at'],
        updatedAt: !exists(json, 'updated_at') ? undefined : json['updated_at'],
        isPin: !exists(json, 'is_pin') ? undefined : json['is_pin'],
        countsOfListItem: !exists(json, 'counts_of_list_item') ? undefined : json['counts_of_list_item']
    };
}
export function CompanyListToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        id: value.id,
        name: value.name,
        created_at: value.createdAt,
        updated_at: value.updatedAt,
        is_pin: value.isPin,
        counts_of_list_item: value.countsOfListItem
    };
}
